"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testBoot = exports.internalBoot = void 0;
const AuthType_1 = __importDefault(require("./AuthType"));
const apiType_1 = require("../apiType");
const ContainerHolder_1 = __importDefault(require("../Container/ContainerHolder"));
const Container_1 = __importDefault(require("../Container/Container"));
const CacheHolder_1 = __importDefault(require("../CacheLayer/CacheHolder"));
const DateTimeProviderMock_1 = __importDefault(require("../Mock/DateTimeProviderMock"));
const config_consts_1 = require("../Container/config.consts");
const DateTimeModifierMock_1 = __importDefault(require("../Mock/DateTimeModifierMock"));
const cache_1 = require("@almservices-cl/cache");
const logger_1 = require("@almservices-cl/logger");
const assertPBPProductionHost_1 = __importDefault(require("../Util/assertPBPProductionHost"));
const TrueTimerMock_1 = __importDefault(require("../Mock/TrueTimerMock"));
const BehaviourType_1 = __importDefault(require("./BehaviourType"));
const ChatType_1 = __importDefault(require("./ChatType"));
const CoachType_1 = __importDefault(require("./CoachType"));
const CustomerType_1 = __importDefault(require("./CustomerType"));
const EnvironmentType_1 = __importDefault(require("./EnvironmentType"));
const NutritionType_1 = __importDefault(require("./NutritionType"));
const RecoveryType_1 = __importDefault(require("./RecoveryType"));
const TrainingType_1 = __importDefault(require("./TrainingType"));
const ResultsType_1 = __importDefault(require("./ResultsType"));
const setLocale_1 = __importDefault(require("./setLocale"));
const NetworkSubscriptionType_1 = __importDefault(require("./NetworkSubscriptionType"));
const clock_1 = require("@almservices-cl/clock");
const TraineeListType_1 = __importDefault(require("./TraineeListType"));
const HistoryType_1 = __importDefault(require("./HistoryType"));
const SportActivitiesType_1 = __importDefault(require("./SportActivitiesType"));
const JournalType_1 = __importDefault(require("./JournalType"));
const internalBoot = async (cache, typeValue, containerValues, // type-coverage:ignore-line
host, isLoggerEnabled = true) => {
    const container = new Container_1.default(typeValue, cache, host);
    container.registerValue(config_consts_1.IS_LOGGER_ENABLED, isLoggerEnabled);
    ContainerHolder_1.default.setInstance(container);
    CacheHolder_1.default.setCache(cache); // TODO: remove
    // type-coverage:ignore-next-line
    containerValues.forEach((instance, name) => {
        // type-coverage:ignore-next-line
        container.registerValue(name, instance);
    });
    await container.warmUp();
    if (typeValue === apiType_1.apiType.PBP_10) {
        (0, assertPBPProductionHost_1.default)(typeValue, host);
    }
};
exports.internalBoot = internalBoot;
const boot = async (cache, typeValue, locale, host, isLoggerEnabled = true) => {
    await (0, exports.internalBoot)(cache, typeValue, new Map(), host, isLoggerEnabled);
    await (0, setLocale_1.default)(locale);
    return {
        AuthType: (0, AuthType_1.default)(),
        BehaviourType: (0, BehaviourType_1.default)(),
        ChatType: (0, ChatType_1.default)(),
        CoachType: (0, CoachType_1.default)(),
        CustomerType: (0, CustomerType_1.default)(),
        EnvironmentType: (0, EnvironmentType_1.default)(typeValue, host),
        NutritionType: (0, NutritionType_1.default)(),
        RecoveryType: (0, RecoveryType_1.default)(),
        TrainingType: (0, TrainingType_1.default)(),
        ResultsType: (0, ResultsType_1.default)(),
        NetworkSubscriptionType: (0, NetworkSubscriptionType_1.default)(),
        TraineeListType: (0, TraineeListType_1.default)(),
        HistoryType: (0, HistoryType_1.default)(),
        SportActivitiesType: (0, SportActivitiesType_1.default)(),
        JournalType: (0, JournalType_1.default)(),
    };
};
exports.default = boot;
const defaultTestContainerValues = () => {
    const map = new Map();
    const systemConfig = new clock_1.DateTimeConfig(new cache_1.InMemoryCache(), {
        dateTime: "YYYY-MM-DDTHH:mm:ssZ",
        date: "YYYY-MM-DD",
        time: "HH:mm:ss",
    });
    const userConfig = new clock_1.DateTimeConfig(new cache_1.InMemoryCache(), {
        dateTime: "YYYY-MM-DDTHH:mm:ssZ",
        date: "YYYY-MM-DD",
        time: "HH:mm:ss",
    });
    map.set(config_consts_1.SYSTEM_DATE_TIME_CONFIG, systemConfig);
    map.set(config_consts_1.USER_DATE_TIME_CONFIG, userConfig);
    map.set(config_consts_1.DATE_TIME_PROVIDER, new DateTimeProviderMock_1.default(userConfig));
    map.set(config_consts_1.DATE_TIME_MODIFIER, new DateTimeModifierMock_1.default(userConfig));
    map.set(config_consts_1.SYSTEM_DATE_TIME_PROVIDER, new DateTimeProviderMock_1.default(systemConfig));
    map.set(config_consts_1.SYSTEM_DATE_TIME_MODIFIER, new DateTimeModifierMock_1.default(systemConfig));
    map.set(config_consts_1.LOGGER_APP, new logger_1.NullLogger());
    map.set(config_consts_1.LOGGER_API, new logger_1.NullLogger());
    map.set(config_consts_1.LOGGER_CACHE, new logger_1.NullLogger());
    map.set(config_consts_1.TIMER, TrueTimerMock_1.default);
    return map;
};
const testBoot = async (cache, typeValue, host, 
// type-coverage:ignore-next-line
containerValues) => {
    if (containerValues) {
        if (!containerValues.has(config_consts_1.TIMER)) {
            containerValues.set(config_consts_1.TIMER, TrueTimerMock_1.default);
        }
        if (!containerValues.has(config_consts_1.LOGGER_API)) {
            containerValues.set(config_consts_1.LOGGER_API, new logger_1.NullLogger());
        }
    }
    await (0, exports.internalBoot)(cache, typeValue, containerValues || defaultTestContainerValues(), host);
    const container = ContainerHolder_1.default.getInstance();
    container.get(config_consts_1.NETWORK_SUBSCRIPTION).init(false);
    return container;
};
exports.testBoot = testBoot;
//# sourceMappingURL=boot.js.map